import { useSelector } from 'react-redux';

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faStar } from "@fortawesome/free-solid-svg-icons";

import classes from "./SummaryTable.module.css"

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const classForValue = (value, target, tolerancy) => {
  // console.log(value, target, tolerancy);
  const v = target - value;
  if (Math.abs(v) <= tolerancy) {
    return 'bg-success'
  } else {
    if (target - value > 0) {
      return 'bg-warning'
    }
    return 'bg-danger'
  }

};

const metas = {
  "fixa": localStorage.getItem("fixa") / 100,
  "acoes": localStorage.getItem("acoes") / 100,
  "fiis": localStorage.getItem("fiis") / 100,
  "stocks": localStorage.getItem("stocks") / 100,
  "etfs": localStorage.getItem("etfs") / 100,
  "reits": localStorage.getItem("reits") / 100,
  "cripto": 0.00,
  "fixaInvestido": localStorage.getItem("fixaInvestido") / 100,
  "acoesInvestido": localStorage.getItem("acoesInvestido") / 100,
  "fiisInvestido": localStorage.getItem("fiisInvestido") / 100,
  "stocksInvestido": localStorage.getItem("stocksInvestido") / 100,
  "etfsInvestido": localStorage.getItem("etfsInvestido") / 100,
  "reitsInvestido": localStorage.getItem("reitsInvestido") / 100,
  "criptoInvestido": 0.00
};

const tolerancy = localStorage.getItem("tolerancy") / 100;
console.warn('bagaé', tolerancy)

const SummaryTable = props => {
  const total = useSelector(state => state.total);
  const totalFixas = useSelector(state => state.totalFixas);
  const totalAcoes = useSelector(state => state.totalAcoes);
  const totalFIIs = useSelector(state => state.totalFIIs);
  const totalStocks = useSelector(state => state.totalStocks);
  const totalETFs = useSelector(state => state.totalETFs);
  const totalREITs = useSelector(state => state.totalREITs);

  const totalInvestido = useSelector(state => state.totalInvestido);
  const totalInvestidoFixas = useSelector(state => state.totalInvestidoFixas);
  const totalInvestidoAcoes = useSelector(state => state.totalInvestidoAcoes);
  const totalInvestidoFIIs = useSelector(state => state.totalInvestidoFIIs);
  const totalInvestidoStocks = useSelector(state => state.totalInvestidoStocks);
  const totalInvestidoETFs = useSelector(state => state.totalInvestidoETFs);
  const totalInvestidoREITs = useSelector(state => state.totalInvestidoREITs);

  const parcelaFixas = totalFixas / (total !== 0 ? total : 1);
  const parcelaAcoes = totalAcoes / (total !== 0 ? total : 1);
  const parcelaFIIs = totalFIIs / (total !== 0 ? total : 1);
  const parcelaStocks = totalStocks / (total !== 0 ? total : 1);
  const parcelaETFs = totalETFs / (total !== 0 ? total : 1);
  const parcelaREITs = totalREITs / (total !== 0 ? total : 1);

  const saldo =
    total -
    (
      totalInvestidoFixas +
      totalInvestidoAcoes +
      totalInvestidoFIIs +
      totalInvestidoStocks +
      totalInvestidoETFs +
      totalInvestidoREITs
    );

  return (
    <>
      <div className="row">
        <div className="col col-md-2 text-end"></div>
        <div className={"col col-md-2 text-center " + classes.bgBrasil}>
          BRASIL
        </div>
        <div className={"col col-md-1 " + classes.bgBrasil}>
          {brlFormatter.format(totalFixas + totalAcoes + totalFIIs)}
        </div>
        <div className={"col col-md-2 text-center " + classes.bgEUA}>
          EUA
        </div>
        <div className={"col col-md-1 " + classes.bgEUA}>
          {brlFormatter.format(totalStocks + totalETFs + totalREITs)}
        </div>
        <div className={"col col-md-2 text-center " + classes.bgCripto}>
          CRIPTO
        </div>
        <div className={"col col-md-1 " + classes.bgCripto}>
          R$ 0,00
        </div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-2 text-end text-muted"><small>Lucratividade:</small></div>
        <div className="col col-md-2"></div>
        <div className="col col-md-1">{brlFormatter.format((totalFixas - totalInvestidoFixas) + (totalAcoes - totalInvestidoAcoes) + (totalFIIs - totalInvestidoFIIs))}</div>
        <div className="col col-md-2"></div>
        <div className="col col-md-1">{brlFormatter.format((totalStocks - totalInvestidoStocks) + (totalETFs - totalInvestidoETFs) + (totalREITs - totalInvestidoREITs))}</div>
        <div className="col col-md-2"></div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-2"></div>
        <div className="col col-md-1">{brlFormatter.format(totalFixas ? totalFixas - totalInvestidoFixas : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoAcoes ? totalAcoes - totalInvestidoAcoes : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoFIIs ? totalFIIs - totalInvestidoFIIs : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoStocks ? totalStocks - totalInvestidoStocks : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoETFs ? totalETFs - totalInvestidoETFs : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoREITs ? totalREITs - totalInvestidoREITs : 0)}</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-1"></div>
        <div className="col col-md-1"></div>
        <div className={"col col-md-1 " + classes.bgRendaFixa}>RENDA FIXA</div>
        <div className={"col col-md-1 " + classes.bgAcoes}>AÇÕES</div>
        <div className={"col col-md-1 " + classes.bgFIIs}>FIIs</div>
        <div className={"col col-md-1 " + classes.bgSTOCKs}>STOCKs</div>
        <div className={"col col-md-1 " + classes.bgETFs}>ETFs</div>
        <div className={"col col-md-1 " + classes.bgREITs}>REITs</div>
        <div className={"col col-md-1 " + classes.bgBITCOIN}>BITCOIN</div>
        <div className={"col col-md-1 " + classes.bgETHEREUM}>ETHEREUM</div>
        <div className={"col col-md-1 " + classes.bgBNB}>BNB</div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-2"></div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoFixas ? totalInvestidoFixas : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoAcoes ? totalInvestidoAcoes : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoFIIs ? totalInvestidoFIIs : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoStocks ? totalInvestidoStocks : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoETFs ? totalInvestidoETFs : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalInvestidoREITs ? totalInvestidoREITs : 0)}</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-2"></div>
        <div className="col col-md-1">{brlFormatter.format(totalFixas ? totalFixas : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalAcoes ? totalAcoes : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalFIIs ? totalFIIs : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalStocks ? totalStocks : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalETFs ? totalETFs : 0)}</div>
        <div className="col col-md-1">{brlFormatter.format(totalREITs ? totalREITs : 0)}</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1">R$ 0,00</div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-2"></div>
        <div className={"col col-md-1 " + classForValue(parcelaFixas, metas.fixa, tolerancy) + " " + classes.advice}>{percentageFormatter.format((totalFixas ? totalFixas : 0) / (total !== 0 ? total : 1))}</div>
        <div className={"col col-md-1 " + classForValue(parcelaAcoes, metas.acoes, tolerancy) + " " + classes.advice}>{percentageFormatter.format((totalAcoes ? totalAcoes : 0) / (total !== 0 ? total : 1))}</div>
        <div className={"col col-md-1 " + classForValue(parcelaFIIs, metas.fiis, tolerancy) + " " + classes.advice}>{percentageFormatter.format((totalFIIs ? totalFIIs : 0) / (total !== 0 ? total : 1))}</div>
        <div className={"col col-md-1 " + classForValue(parcelaStocks, metas.stocks, tolerancy) + " " + classes.advice}>{percentageFormatter.format((totalStocks ? totalStocks : 0) / (total !== 0 ? total : 1))}</div>
        <div className={"col col-md-1 " + classForValue(parcelaETFs, metas.etfs, tolerancy) + " " + classes.advice}>{percentageFormatter.format((totalETFs ? totalETFs : 0) / (total !== 0 ? total : 1))}</div>
        <div className={"col col-md-1 " + classForValue(parcelaREITs, metas.reits, tolerancy) + " " + classes.advice}>{percentageFormatter.format((totalREITs ? totalREITs : 0) / (total !== 0 ? total : 1))}</div>
        <div className={"col col-md-1 bg-success " + classes.advice}>0%</div>
        <div className={"col col-md-1 bg-warning " + classes.advice}>0%</div>
        <div className={"col col-md-1 bg-success " + classes.advice}>0%</div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-1"></div>
        <div className="col col-md-1 text-end">METAS:</div>
        <div className="col col-md-1">{percentageFormatter.format(metas.fixa)}</div>
        <div className="col col-md-1">{percentageFormatter.format(metas.acoes)}</div>
        <div className="col col-md-1">{percentageFormatter.format(metas.fiis)}</div>
        <div className="col col-md-1">{percentageFormatter.format(metas.stocks)}</div>
        <div className="col col-md-1">{percentageFormatter.format(metas.etfs)}</div>
        <div className="col col-md-1">{percentageFormatter.format(metas.reits)}</div>
        <div className="col col-md-1">{percentageFormatter.format(metas.cripto)}</div>
        <div className="col col-md-1">0%</div>
        <div className="col col-md-1">0%</div>
        <div className="col col-md-1"></div>
      </div>

      <div className="row">
        <div className="col col-md-1"></div>
        <div className="col col-md-1 text-end">TOLERÂNCIA:</div>
        <div className="col col-md-1">{percentageFormatter.format(tolerancy)}</div>
        <div className="col col-md-9"></div>
      </div>

      <div className='row pt-5'>
        <div className="col col-md-1"></div>
        <div className="col col-md-1 text-end">TOTAL:</div>
        <div className={"col col-md-1 " + classes.bgTotalHeader1}><i className="text-dark">Atual</i></div>
        <div className={"col col-md-1 " + classes.bgTotalHeader2}><i className="text-dark">Investido</i></div>
        <div className={"col col-md-1 " + classes.bgTotalHeader1}><i className="text-dark">Lucratividade</i></div>
        <div className="col col-md-7"></div>
      </div>

      <div className='row'>
        <div className="col col-md-1"></div>
        <div className="col col-md-1"></div>
        <div className={"col col-md-1 " + classes.bgTotal1}><strong>{brlFormatter.format(total)}</strong></div>
        <div className={"col col-md-1 " + classes.bgTotal2}><strong>{brlFormatter.format(totalInvestidoFixas + totalInvestidoAcoes + totalInvestidoFIIs + totalInvestidoStocks + totalInvestidoETFs + totalInvestidoREITs)}</strong></div>
        <div className={"col col-md-1 " + classes.bgTotal1}><strong className={saldo < 0 ? 'text-danger' : 'text-success'}>
          {brlFormatter.format(saldo)}
        </strong>
        </div>
        <div className="col col-md-7"></div>
      </div>

      <div className='row'>
        <div className="col col-md-4"></div>
        <div className={"col col-md-1 text-muted text-end"}><i>{percentageFormatter.format(saldo/total)}</i></div>
        <div className="col col-md-7"></div>
      </div>
    </ >
  )
};

export default SummaryTable;